import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Trash from 'apollo-react-icons/Trash';
import React from 'react';

const DirectionCell = ({ row, column: { accessor: key } }) => {
  const options = [
    { label: 'ASC', value: 'ASC', key: 'asc' },
    { label: 'DESC', value: 'DESC', key: 'desc' },
  ];
  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        canDeselect={false}
        value={row[key]}
        disabled={row.disabled}
        onChange={({ target: { value } }) =>
          row.updateRow({ index: row.index, newRow: { ...row, direction: value }, action: 'edit' })
        }
      >
        {options.map(({ label, value }) => {
          return (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

const FieldCell = ({ row, column: { accessor: key } }) => {
  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        canDeselect={false}
        value={row[key]}
        disabled={row.disabled}
        onChange={({ target: { value } }) =>
          row.updateRow({
            index: row.index,
            newRow: { ...row, field: value, translatedField: value },
            action: 'edit',
          })
        }
      >
        {row.fieldList &&
          row.fieldList.map(({ label, value }) => {
            return (
              <MenuItem key={value} value={value}>
                {`${label} (${value})`}
              </MenuItem>
            );
          })}
      </Select>
    </div>
  );
};

const ActionCell = ({ row }) => {
  return (
    <div style={{ width: 68 }}>
      <IconButton
        size="small"
        style={{ marginRight: 4 }}
        onClick={() => row.updateRow({ index: row.index, newRow: {}, action: 'delete' })}
        disabled={row.disabled}
      >
        <Trash />
      </IconButton>
    </div>
  );
};

const columns = [
  {
    header: 'Field',
    accessor: 'field',
    customCell: FieldCell,
  },
  {
    header: 'Direction',
    accessor: 'direction',
    customCell: DirectionCell,
  },
  {
    accessor: 'action',
    customCell: ActionCell,
    width: 68,
  },
];

export default columns;
